export class AccidentIndicator {
    name: string;
    id: number;
    code: string;
}